import React, { useState } from "react";
import "./ChorusFunders.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMinus,
  faDownload,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import crossref_logo from "../../components/assets/images/Powered_by_CrossRef.png";
import ror_logo from "../../components/assets/images/ROR_logo.png";
import AxiosService from "../../utils/AxiosService";

// import React, { useState } from "react";
// import "./ChorusFunders.scss";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPlus, faMinus, faDownload, faSpinner } from "@fortawesome/free-solid-svg-icons";
// import crossref_logo from "../assets/images/Powered_by_CrossRef.png";
// import ror_logo from "../assets/images/ROR_logo.png";
// // IMPORT YOUR axiosService HERE
// // import axiosService from "../../path/to/axiosService";

const initialFunderData = [
  {
    id: "100000001",
    rorId: "https://ror.org/021nxhr62",
    name: "NATIONAL SCIENCE FOUNDATION",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000005",
    rorId: "https://ror.org/0447fe631",
    name: "U.S. DEPARTMENT OF DEFENSE",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000014",
    rorId: "https://ror.org/01pp8nd67",
    name: "SMITHSONIAN INSTITUTION",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000015",
    rorId: "https://ror.org/01bj3aw27",
    name: "U.S. DEPARTMENT OF ENERGY",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000104",
    rorId: "https://ror.org/027ka1x80",
    name: "NATIONAL AERONAUTICS AND SPACE ADMINISTRATION",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000161",
    rorId: "https://ror.org/05xpvk416",
    name: "NATIONAL INSTITUTE OF STANDARDS AND TECHNOLOGY",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000192",
    rorId: "https://ror.org/02z5nhe81",
    name: "NATIONAL OCEANIC AND ATMOSPHERIC ADMINISTRATION",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000199",
    rorId: "https://ror.org/01na82s61",
    name: "U.S. DEPARTMENT OF AGRICULTURE",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000200",
    rorId: "https://ror.org/01n6e6j62",
    name: "U.S. AGENCY FOR INTERNATIONAL DEVELOPMENT",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100000203",
    rorId: "https://ror.org/035a68863",
    name: "U.S. GEOLOGICAL SURVEY",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100011038",
    rorId: "https://ror.org/01v3fsc55",
    name: "OFFICE OF THE DEPARTMENT OF NATIONAL INTELLIGENCE",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "100011039",
    rorId: "https://ror.org/01v3fsc55",
    name: "INTELLIGENCE ADVANCED RESEARCH PROJECTS ACTIVITY",
    children: [],
    hasChildren: false,
    isParent: true,
  },
  {
    id: "501100000943",
    rorId: "https://ror.org/03qn8fb07",
    name: "COMMONWEALTH SCIENTIFIC AND INDUSTRIAL RESEARCH ORGANISATION",
    children: [],
    hasChildren: true,
    isParent: true,
  },
  {
    id: "501100002241",
    rorId: "https://ror.org/00097mb19",
    name: "JAPAN SCIENCE AND TECHNOLOGY AGENCY",
    children: [],
    hasChildren: true,
    isParent: true,
  },
];

const FunderRow = ({
  item,
  expandedRows,
  loadingRows,
  toggleRow,
  isFirstChild,
  groupRorId,
}) => {
  const rowKey = item.id ? item.id.toString() : item.name;
  const isExpanded = expandedRows.has(rowKey);
  const isLoading = loadingRows.has(rowKey);

  // Filter out the dummy "more" children elements
  const displayChildren = item.children || [];

  const hasChildren = item?.isParent
    ? item.hasChildren
    : item.children.length > 0
      ? !item.childrenLoaded || displayChildren.length > 0
      : false;

  const displayRorId = item.rorId
    ? item.rorId
    : isFirstChild && groupRorId
      ? groupRorId
      : "";

  return (
    <>
      {/* Main Row */}
      <tr
        className="main-row"
        onClick={() => hasChildren && !isLoading && toggleRow(item)}
        style={{
          cursor: hasChildren && !isLoading ? "pointer" : "default",
        }}
      >
        <td style={{ width: "25%" }}>
          {displayRorId && <span>{displayRorId}</span>}
        </td>
        <td style={{ width: "20%" }}>{item.id}</td>
        <td>
          <span className="d-flex justify-content-between align-items-center border-bottom-0">
            <span
              className={item.hasChildren || item.isParent ? "fw-bold" : ""}
            >
              {item.name}
            </span>

            {isLoading ? (
              <span
                style={{
                  display: "inline-block",
                  width: "24px",
                  textAlign: "right",
                }}
              >
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  className="text-secondary"
                />
              </span>
            ) : hasChildren &&
              (item.hasChildren || item?.children?.length > 0) ? (
              <span
                className="toggle-btn"
                aria-label={isExpanded ? "Collapse row" : "Expand row"}
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                  width: "24px",
                  textAlign: "right",
                }}
              >
                {isExpanded ? (
                  <FontAwesomeIcon icon={faMinus} />
                ) : (
                  <FontAwesomeIcon icon={faPlus} />
                )}
              </span>
            ) : (
              <span style={{ display: "inline-block", width: "24px" }}></span>
            )}
          </span>
        </td>
      </tr>

      {/* Recursive Render for Sub-Items */}
      {isExpanded && displayChildren.length > 0 && (
        <tr className="sub-row-wrapper">
          <td colSpan="3" className="p-0 border-0">
            <table className="table sub-table mb-0 w-100">
              <tbody>
                {displayChildren.map((child, idx) => (
                  <FunderRow
                    key={child.id || idx}
                    item={child}
                    expandedRows={expandedRows}
                    loadingRows={loadingRows}
                    toggleRow={toggleRow}
                    isFirstChild={idx === 0}
                    groupRorId={item.rorId || groupRorId}
                  />
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      )}
    </>
  );
};

const ChorusFunders = () => {
  const [funders, setFunders] = useState(initialFunderData);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [loadingRows, setLoadingRows] = useState(new Set());

  const axiosService = new AxiosService();

  // Recursive function to deeply update the specific node in the nested data tree
  const updateTreeWithChildren = (nodes, parentId, newChildren) => {
    return nodes.map((node) => {
      if (node.id === parentId) {
        return { ...node, children: newChildren, childrenLoaded: true };
      }
      if (node.children && node.children.length > 0) {
        return {
          ...node,
          children: updateTreeWithChildren(
            node.children,
            parentId,
            newChildren,
          ),
        };
      }
      return node;
    });
  };

  const toggleRow = (item) => {
    const rowKey = item.id;
    const isExpanded = expandedRows.has(rowKey);

    // If it's already expanded, just collapse it
    if (isExpanded) {
      setExpandedRows((prev) => {
        const newExpanded = new Set(prev);
        newExpanded.delete(rowKey);
        return newExpanded;
      });
      return;
    }

    // If we haven't loaded children for this item yet, trigger API fetch
    if (!item.childrenLoaded) {
      setLoadingRows((prev) => new Set(prev).add(rowKey));

      // Trigger your actual API call
      axiosService
        .getSearchFunder({ expandId: rowKey, isExpand: true })
        .then((res) => {
          // Adjust this path slightly if your axios setup differs
          // (e.g., if interceptors strip `.data`, you might just use `res.tree.children`)
          const fetchedChildren =
            res.data?.tree?.children || res.tree?.children || [];

          setFunders((prevFunders) =>
            updateTreeWithChildren(prevFunders, rowKey, fetchedChildren),
          );

          // Only expand the row after the data is successfully set
          setExpandedRows((prev) => new Set(prev).add(rowKey));
        })
        .catch((err) => {
          console.error("Error fetching funder:", err);
          // Optional: handle error state or show a toast notification here
        })
        .finally(() => {
          // Remove the loading spinner regardless of success or failure
          setLoadingRows((prev) => {
            const newSet = new Set(prev);
            newSet.delete(rowKey);
            return newSet;
          });
        });
    } else {
      // If data is already loaded, just expand immediately
      setExpandedRows((prev) => new Set(prev).add(rowKey));
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row  justify-content-between align-items-center bg-light border px-3 py-3">
        <h2 className=" text-secondary fs-4">CHORUS Participating Funders</h2>

        <div className="d-flex flex-column flex-sm-row gap-2">
          <a
            href="https://s3.amazonaws.com/chorus-public-assets/production/funders.csv"
            className="btn bg-white border text-secondary fw-bold d-flex align-items-center gap-1"
          >
            <FontAwesomeIcon icon={faDownload} />
            DOWNLOAD AS CSV
          </a>

          <a
            href="https://s3.amazonaws.com/chorus-public-assets/production/funders.xlsx"
            className="btn bg-white border text-secondary fw-bold d-flex align-items-center gap-1"
          >
            <FontAwesomeIcon icon={faDownload} />
            DOWNLOAD AS XLSX
          </a>
        </div>
      </div>

      <div className="chorus-funders-container container-lg my-4">
        <p className="description-text text-center mb-4">
          This is a list of CHORUS Funder Participants and associated RoR and
          Funder IDs.
        </p>

        <div className="table-responsive table-wrapper">
          <table className="table chorus-table">
            <thead>
              <tr>
                <th style={{ width: "25%" }}>ROR ID</th>
                <th style={{ width: "20%" }}>Funder ID</th>
                <th style={{ width: "55%" }}>Funder Name</th>
              </tr>
            </thead>
            <tbody>
              {funders.map((row) => (
                <FunderRow
                  key={row.id}
                  item={row}
                  expandedRows={expandedRows}
                  loadingRows={loadingRows}
                  toggleRow={toggleRow}
                  isFirstChild={false}
                  groupRorId={null}
                />
              ))}
            </tbody>
          </table>
        </div>

        <div className="image-container my-3">
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-3">
            <a
              href="https://search.crossref.org/fundref"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={crossref_logo}
                alt="Crossref"
                className="img-fluid logo-img"
              />
            </a>
            <a href="https://ror.org/" target="_blank" rel="noreferrer">
              <img src={ror_logo} alt="ROR" className="img-fluid logo-img" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChorusFunders;
